var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M13.001 28.051H8.334c-4.344 0-6.277-2.095-6.277-6.801v-5.055c0-4.707 1.933-6.801 6.277-6.801h4.667c4.345 0 6.278 2.094 6.278 6.8v5.056c0 4.706-1.933 6.801-6.278 6.801M8.334 11.199c-3.444 0-4.61 1.264-4.61 4.996v5.055c0 3.732 1.166 4.995 4.61 4.995h4.667c3.444 0 4.611-1.264 4.611-4.995v-5.055c0-3.732-1.166-4.996-4.61-4.996z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M19.667 20.828h-1.222c-.456 0-.834-.409-.834-.902v-3.732c0-3.731-1.166-4.995-4.61-4.995H9.555c-.456 0-.833-.41-.833-.903V8.972c0-4.707 1.933-6.801 6.277-6.801h4.667c4.345 0 6.278 2.094 6.278 6.8v5.056c0 4.707-1.933 6.801-6.278 6.801zm-.389-1.805h.39c3.444 0 4.61-1.264 4.61-4.996V8.972c0-3.732-1.166-4.996-4.61-4.996H15c-3.444 0-4.61 1.264-4.61 4.996v.421H13c4.345 0 6.278 2.095 6.278 6.801z"
  })));
};
export default SvgCopy;